import React, { Component } from "react";
import { isObject } from 'lodash';
import { Link } from "react-router-dom";
import SectionImageText from "./SectionImageText";

import backgroundText from "../assets/backgrounds/background-text.jpg";

import "../styles/components/SectionOfferContent.css";

export default class SectionOfferContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFirefox: typeof InstallTrigger !== "undefined"
    };
  }

  offerContectUpperText = upperText => {
    if (upperText.leftSide) {
      return (
        <div className="row offer-content--upper-text">
          <div className={`col-12 col-md-6`}>
            {upperText.leftSide.map((item, idx) => {
              return (
                <h4 className={idx === 0 ? "color-orange" : ""} key={idx}>
                  {item.paragraphs}
                </h4>
              );
            })}
          </div>
          <div className={`col-12 col-md-5`}>
            {upperText.rightSide.map((item, idx) => {
              return (
                <React.Fragment key={idx}>
                  <h5>{item.title}</h5>
                  <p>{item.desc}</p>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  offerContentSeparator = textImageSection => {
    return (
      <div className="row offer-content--separator">
        <div className="col-12">
          <div className="row">
            <SectionImageText
              wrapperClasses={`col-12`}
              text={textImageSection.header}
              backgroundImage={textImageSection.photoUrl}
              paddingTop={240}
              paddingBottom={110}
            />
          </div>
          <div className="row">
            <div className="col-12 col-md-9 offset-md-3">
              <p>{textImageSection.descGrey}</p>
              <p style={{ color: "black" }}>{textImageSection.descBlack}</p>
              {textImageSection.button.map((button, idx) => {
                return (
                  <Link
                    key={idx}
                    className={`btn-general btn-general--${
                      idx === 0 ? "primary" : "secondary"
                    }`}
                    to={button.buttonUrl}
                  >
                    {button.buttonText}
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="section-offer-content">
        <div className="container container-small">
          {this.props.data.upperText &&
            this.offerContectUpperText(this.props.data.upperText)}
          {!this.state.isFirefox ? (
            !['fleet', 'cars'].includes(this.props.type) && (
              <SectionImageText
                wrapperClasses={`col-12 two-line`}
                text={`Korzyści`}
                secLine={`V1RAGE`}
                backgroundImage={backgroundText}
                paddingTop={0}
                paddingBottom={0}
              />
            )
          ) : (
            <div className="`col-12 two-line`" style={{ height: "150px" }} />
          )}
          {this.props.data.contentSingle &&
            this.props.data.contentSingle.map((item, idx, arr) => {
              return (
                <React.Fragment key={idx}>
                  <div
                    className={`row offer-content--single ${
                      arr.length === 1 ? "single-item" : ""
                    } ${
                      this.props.data.contentSingle.length > 1 &&
                      idx === this.props.data.contentSingle.length - 2 &&
                      this.props.type !== "cars"
                        ? "no-margin"
                        : ""
                    }`}
                    key={idx}
                  >
                    <div
                      className={`col-12 ${this.props.type !== "cars" ? 'col-md-4 image--limit-width' : 'col-md-6'}
                      ${item.left ? "order-1" : "order-2"}
                      ${item.half ? "half" : ""} `}
                    >
                      <img src={item.imageSrc} alt="" />
                    </div>
                    <div
                      className={`col-12 col-md-5 ${item.left  ? "order-2" : "order-1"} `}
                    >
                      {(arr.length > 1 && this.props.type !== "cars") && (
                        <h5>
                          <span>{"0" + ++idx}.</span>
                          {item.title}
                        </h5>
                      )}
                      {this.props.type === "cars" && item.title && (
                        <h5 style={{color: '#8f9092'}}>
                          <span>{"0" + ++idx}.</span>
                          {item.title}
                        </h5>
                      )}
                      <div className="row">
                        {item.columns.map((item2, idx2) => {
                          return (
                            <div
                              className={
                                !item2.half ? "col-12 col-md-6" : "col-12"
                              }
                              key={idx2}
                            >
                              {this.props.type === "cars" && item2.title && (
                                <h5 style={{color: '#8f9092'}}>
                                  <span>{"0" + ++idx2}.</span>
                                  {item2.title}
                                </h5>
                              )}
                              {item2.subTitle && <h4>{item2.subTitle}</h4>}
                              {item2.desc && <p dangerouslySetInnerHTML={{ __html: item2.desc }} />}
                              {isObject(item2.button) &&
                                <a className="btn-general btn-general--primary" href={item2.button.url} target={item2.button.target}>
                                  {item2.button.title}
                                </a>
                              }
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  {this.props.type !== "cars" && arr.length > 1 &&
                    idx === arr.length - 1 &&
                    this.offerContentSeparator(
                      this.props.data.textImageSection
                    )}
                  {this.props.type !== "cars" && arr.length === 1 &&
                    this.offerContentSeparator(
                      this.props.data.textImageSection
                    )}
                </React.Fragment>
              );
            })}
        </div>
      </div>
    );
  }
}
